import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CreditCard, Lock } from 'lucide-react';
export function PaymentCTA() {
  return <section id="payment" className="py-20 bg-brand-gray border-y border-gray-200" data-id="element-263">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-10 md:p-14 rounded-2xl shadow-sm border border-gray-100" data-id="element-265">
          <div className="w-16 h-16 bg-brand-red/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-266">
            <CreditCard className="text-brand-red" size={32} data-id="element-267" />
          </div>

          <h2 className="text-3xl font-bold text-brand-navy mb-4" data-id="element-268">
            Need to make a payment?
          </h2>

          <p className="text-lg text-brand-muted mb-8 max-w-2xl mx-auto" data-id="element-269">
            We offer a secure, convenient way to resolve your account online.
            Our portal is available 24/7, allowing you to manage your balance on
            your schedule.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-270">
            <Link to="/portal" className="w-full sm:w-auto bg-brand-red hover:bg-red-800 text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-md flex items-center justify-center gap-2" data-id="element-271">
              Access Payment Portal
            </Link>
          </div>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-brand-muted" data-id="element-272">
            <Lock size={16} data-id="element-273" />
            <span data-id="element-274">Secure, encrypted transaction</span>
          </div>
        </motion.div>
      </div>
    </section>;
}